import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Amplitude from "@Shared/utils/amplitude";
import DocumentPreviewModal from "@Shared/components/document-previewer/document-preview-modal.vue";
import CreditApplicants from "./credit-applicants";
import CreditReportTable from "./credit-report-table";
import AdditionalCreditReportTable from "./credit-additional-report-table.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import Err from "../../../../../../../../routes/error";
import { LOAD_CREDIT_SUBJECTS, LOAD_CREDIT_REPORTS, LOAD_ADDITIONAL_REPORTS, PRINT_DOCUMENT_FORM, REQUEST_CREDIT_BUREAU, REQUEST_AML_SERVICE, COPY_LIABILITIES_FROM_CB, CHANGE_REPORT_SUBMIT_TO_LENDER } from "../../../../store/lender-submit-actions";
import { CURRENT_ACCOUNT_ACCESS_RIGHTS, CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY } from "@Broker/@Modules/main/store/account/account-getters";
import { DOWNLOAD_DOCUMENT } from "../../../../../documents/store/documents-actions";
import { LOAD_APPLICATION_DATA, LOAD_CALCULATIONS_DATA } from "../../../../store/application-actions";
import { openFileDialog } from "@Shared/utils/utils";
import { showToast } from "@Shared/utils/constants";
import { isEmpty, pickBy, values } from "lodash";
import { MISSING_FILOGIX_DETAILS_FOR_CREDIT_PULL } from "@Broker/@Modules/settings/store/settings-getters";
import { defineComponent } from "@vue/composition-api";
import { LOAD_PERSONAL_DETAILS } from "@Broker/@Modules/main/store/account/account-actions";
import WidgetEventsMixin from "@Shared/utils/application-mixins/widget-events-mixin";
export default defineComponent({
  name: "CreditBureauContainer",
  components: {
    CreditApplicants,
    CreditReportTable,
    AdditionalCreditReportTable,
    DocumentPreviewModal
  },
  mixins: [WidgetEventsMixin],
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    agentUsername: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loadingCreditSubjects: false,
      loadingCreditReports: false,
      loadingAdditionalReports: false,
      reportDocumentData: {
        documentId: "",
        url: "",
        pdfDocumentId: "",
        pdfUrl: "",
        creditReportType: false,
        AMLReportType: false,
        PEPReportType: false
      },
      errors: [],
      displayClassicLayout: false,
      loadingReportPdf: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState("ApplicationStore", ["creditReports", "additionalReports"])), mapState("DocumentsStore", ["documents"])), mapGetters("SettingsStore", [MISSING_FILOGIX_DETAILS_FOR_CREDIT_PULL])), mapGetters("AccountStore", [CURRENT_ACCOUNT_ACCESS_RIGHTS, CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY])), {}, {
    missingFilogixDetailsForCreditPulls() {
      return this.MISSING_FILOGIX_DETAILS_FOR_CREDIT_PULL;
    },
    requestCreditBureausRight() {
      var _this$CURRENT_ACCOUNT;
      return ((_this$CURRENT_ACCOUNT = this.CURRENT_ACCOUNT_ACCESS_RIGHTS) == null ? void 0 : _this$CURRENT_ACCOUNT.requestCreditBureaus) && !this.CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY;
    },
    currentUrl() {
      if (this.displayClassicLayout || !this.reportDocumentData.pdfUrl) return this.reportDocumentData.url;
      return this.reportDocumentData.pdfUrl;
    },
    currentDocumentId() {
      if (this.displayClassicLayout || !this.reportDocumentData.pdfDocumentId) return this.reportDocumentData.documentId;
      return this.reportDocumentData.pdfDocumentId;
    },
    isAMLReport() {
      return this.reportDocumentData.AMLReportType;
    },
    isPEPReport() {
      return this.reportDocumentData.PEPReportType;
    },
    isCreditReport() {
      return this.reportDocumentData.creditReportType;
    },
    showLayoutToggler() {
      return !!this.reportDocumentData.documentId;
    }
  }),
  watch: {
    requestCreditBureausRight: {
      handler(value) {
        this.errors = value === false ? [{
          errMsg: this.$t("direct-to-lender.lenderSubmit.insufficientPermissions")
        }] : [];
      },
      immediate: true
    },
    missingFilogixDetailsForCreditPulls: {
      handler(value) {
        this.errors = value && this.requestCreditBureausRight ? [{
          errMsg: this.$t("direct-to-lender.creditBureau.pullCreditReportsErr")
        }] :
        // When both insufficientPermissions and pullCreditReportsErr occur,
        // continue to show insufficientPermissions error
        this.errors;
      },
      immediate: true
    }
  },
  async mounted() {
    var _this$accountDetails, _this$accountDetails$;
    this.loadData();
    await this.LOAD_PERSONAL_DETAILS();
    this.errors = (_this$accountDetails = this.accountDetails) != null && (_this$accountDetails$ = _this$accountDetails.accessRights) != null && _this$accountDetails$.viewOnly ? [{
      errMsg: this.$t("direct-to-lender.lenderSubmit.insufficientPermissions")
    }] : this.errors;
  },
  activated() {
    this.loadData();
  },
  methods: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapActions("ApplicationStore", [LOAD_CREDIT_SUBJECTS, LOAD_CREDIT_REPORTS, LOAD_ADDITIONAL_REPORTS, REQUEST_CREDIT_BUREAU, REQUEST_AML_SERVICE, LOAD_APPLICATION_DATA, PRINT_DOCUMENT_FORM, COPY_LIABILITIES_FROM_CB, CHANGE_REPORT_SUBMIT_TO_LENDER, LOAD_CALCULATIONS_DATA])), mapActions("DocumentsStore", [DOWNLOAD_DOCUMENT])), mapActions("AccountStore", [LOAD_PERSONAL_DETAILS])), {}, {
    loadData() {
      this.loadCreditSubjects();
      this.loadCreditReports();
      this.loadAdditionalReports();
    },
    async loadCreditSubjects() {
      this.loadingCreditSubjects = true;
      await this.LOAD_CREDIT_SUBJECTS({
        clientUsername: this.clientUsername,
        applicationId: this.applicationId
      });
      this.loadingCreditSubjects = false;
    },
    async loadCreditReports() {
      this.loadingCreditReports = true;
      await this.LOAD_CREDIT_REPORTS({
        clientUsername: this.clientUsername,
        applicationId: this.applicationId
      });
      this.loadingCreditReports = false;
    },
    async loadAdditionalReports() {
      this.loadingAdditionalReports = true;
      await this.LOAD_ADDITIONAL_REPORTS({
        clientUsername: this.clientUsername,
        applicationId: this.applicationId
      });
      this.loadingAdditionalReports = false;
    },
    async requestAMLService() {
      try {
        const {
          clientUsername,
          applicationId
        } = this;
        const res = await this.REQUEST_AML_SERVICE({
          clientUsername,
          applicationId
        });
        if (res != null && res.success) {
          showToast("success", "AmlReportRequested");
        } else {
          showToast("error", "AmlReportNotRequested");
        }
      } catch (e) {
        showToast("error", "AmlReportNotRequested");
      } finally {
        await this.LOAD_ADDITIONAL_REPORTS({
          clientUsername: this.clientUsername,
          applicationId: this.applicationId
        });
      }
    },
    async requestPEPService() {
      try {
        const {
          clientUsername,
          applicationId
        } = this;
        const res = await this.REQUEST_AML_SERVICE({
          clientUsername,
          applicationId,
          pepRequest: true
        });
        if (res != null && res.success) {
          showToast("success", "PepReportRequested");
        } else {
          showToast("error", "PepReportNotRequested");
        }
      } catch (e) {
        showToast("error", "PepReportNotRequested");
      } finally {
        await this.LOAD_ADDITIONAL_REPORTS({
          clientUsername: this.clientUsername,
          applicationId: this.applicationId
        });
      }
    },
    async requestBureau() {
      const {
        clientUsername,
        applicationId,
        agentUsername
      } = this;
      this.errors = [];
      const res = await this.REQUEST_CREDIT_BUREAU({
        clientUsername,
        applicationId
      });
      if (!res) return;
      await this.LOAD_CREDIT_REPORTS({
        clientUsername,
        applicationId
      });
      const currentReports = pickBy(this.creditReports.byId, report => {
        var _context;
        return _includesInstanceProperty(_context = res.creditBureauIds).call(_context, report.id);
      });
      const currentSuccessReports = pickBy(currentReports, report => report.success);
      const currentFailedReports = pickBy(currentReports, report => !report.success);
      if (isEmpty(currentFailedReports)) {
        showToast("success", "creditBureauRequested");
        this.LOAD_CALCULATIONS_DATA({
          clientUsername: this.clientUsername,
          applicationId: this.applicationId
        });
      } else {
        var _context3;
        if (!isEmpty(currentSuccessReports)) {
          var _context2;
          const successMessages = _mapInstanceProperty(_context2 = values(currentSuccessReports)).call(_context2, report => {
            const {
              firstName,
              lastName
            } = report;
            return {
              applicantName: `${firstName} ${lastName}`
            };
          });
          this.errors = successMessages;
        }
        const errorReports = _mapInstanceProperty(_context3 = values(currentFailedReports)).call(_context3, report => {
          const {
            firstName,
            lastName,
            error
          } = report;
          const errMsg = _mapInstanceProperty(error).call(error, err => err.description);
          return {
            applicantName: `${firstName} ${lastName}`,
            errMsg
          };
        });
        this.errors.push(...errorReports);
        this.errors.push({
          errMsg: this.$t("direct-to-lender.creditBureau.hoverOverFailedBadge")
        });
      }
      this.LOAD_APPLICATION_DATA({
        clientUsername,
        applicationId,
        agentUsername
      });
    },
    async handlePrintConsent() {
      const button = $(".print-consent-form");
      try {
        button.animateButton().animate("start");
        const forms = [{
          type: "consentForm",
          province: "FEDERAL",
          mortgage: "first"
        }];
        const payload = {
          clientUsername: this.clientUsername,
          applicationId: this.applicationId,
          forms
        };
        await this.PRINT_DOCUMENT_FORM(payload);
        await button.animateButton().animate("finish");
      } catch (e) {
        Err.handle(e);
        button.animateButton().animate("finish", "failed");
      }
    },
    async handleCopyLiabilities({
      currentId,
      index
    }) {
      const {
        applicationId,
        clientUsername,
        agentUsername
      } = this;
      try {
        const payload = this.creditReports.byId[currentId];
        await this.COPY_LIABILITIES_FROM_CB({
          applicationId,
          clientUsername,
          agentUsername,
          reportId: currentId,
          payload
        });
        this.$refs.creditReportTable.stopLoader({
          type: "copy",
          status: true,
          index
        });
      } catch (e) {
        this.$refs.creditReportTable.stopLoader({
          type: "copy",
          status: false,
          index
        });
      }
    },
    async handlePreviewAdditionalReport({
      index,
      pdfDocumentId
    }) {
      try {
        var _context4, _context5;
        this.reportDocumentData = _objectSpread(_objectSpread({}, this.reportDocumentData), {}, {
          pdfDocumentId,
          AMLReportType: _includesInstanceProperty(_context4 = this.additionalReports[index - 1].type).call(_context4, "Assist"),
          PEPReportType: _includesInstanceProperty(_context5 = this.additionalReports[index - 1].type).call(_context5, "Sanctions")
        });
        this.displayClassicLayout = !pdfDocumentId;
        await this.loadReportPdf();
        this.$refs.additionalCreditReportTable.stopLoader(index);
        this.$refs.previewCreditModal.show();
      } catch (e) {
        this.$refs.creditReportTable.stopLoader({
          type: "preview",
          status: false,
          index
        });
        showToast("error", "creditBureauNoPreview");
      }
    },
    async handlePreviewCreditReport({
      documentId,
      pdfDocumentId,
      index
    }) {
      try {
        this.reportDocumentData = _objectSpread(_objectSpread({}, this.reportDocumentData), {}, {
          documentId,
          pdfDocumentId,
          creditReportType: true
        });
        this.displayClassicLayout = !pdfDocumentId;
        await this.loadReportPdf();
        this.$refs.creditReportTable.stopLoader({
          type: "preview",
          status: true,
          index
        });
        this.$refs.previewCreditModal.show();
      } catch (e) {
        this.$refs.creditReportTable.stopLoader({
          type: "preview",
          status: false,
          index
        });
        showToast("error", "creditBureauNoPreview");
      }
    },
    async handleDownloadCreditReport() {
      try {
        openFileDialog(this.currentUrl);
      } catch (e) {
        const message = "cannotDownloadFile";
        showToast("error", message);
        Amplitude.logHandledError(e, {}, message);
      }
    },
    async handleChangeSubmitToLender({
      id,
      submitToLender
    }) {
      await this.CHANGE_REPORT_SUBMIT_TO_LENDER({
        applicationId: this.applicationId,
        clientUsername: this.clientUsername,
        reportId: id,
        value: !submitToLender
      });
      this.LOAD_CALCULATIONS_DATA({
        clientUsername: this.clientUsername,
        applicationId: this.applicationId
      });
      this.sendWidgetMessage("validation-rules", "refresh");
    },
    async loadReportPdf() {
      this.loadingReportPdf = true;
      const loadClassicLayout = this.displayClassicLayout || !this.reportDocumentData.pdfDocumentId;
      const {
        url
      } = await this.DOWNLOAD_DOCUMENT({
        documentId: loadClassicLayout ? this.reportDocumentData.documentId : this.reportDocumentData.pdfDocumentId,
        applicationId: this.applicationId,
        clientUsername: this.clientUsername
      });
      this.reportDocumentData.url = loadClassicLayout ? url : "";
      this.reportDocumentData.pdfUrl = loadClassicLayout ? "" : url;
      this.loadingReportPdf = false;
    },
    async handleToggleReportLayout() {
      this.displayClassicLayout = !this.displayClassicLayout;
      await this.loadReportPdf();
    },
    resetReportDocumentData() {
      this.reportDocumentData = {
        documentId: "",
        url: "",
        pdfDocumentId: "",
        pdfUrl: "",
        creditReportType: false,
        AMLReportType: false,
        PEPReportType: false
      };
    }
  })
});